export default "__VITE_ASSET__BAWg_dCS__"